import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBarTabsComponent } from './top-bar-tabs/top-bar-tabs.component';
import { JupiterRedirectComponent } from './jupiter-redirect/jupiter-redirect.component';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommitteeApprovalDashboardComponent } from '../committee-approval-dashboard/committee-approval-dashboard.component';
import { CommitteeDealInformationComponent } from '../committee-approval-dashboard/committee-deal-information/committee-deal-information.component';
import { CommitteeLinksComponent } from '../committee-approval-dashboard/committee-links/committee-links.component';
import { DisclosuresEditorComponent } from '../committee-approval-dashboard/disclosures-editor/disclosures-editor.component';
import { CalendarTooltipComponent } from './calendar-tooltip/calendar-tooltip.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommitteeVotesComponent } from '../committee-approval-dashboard/committee-votes/committee-votes.component';
import { CommitteeVoteComponent } from '../committee-approval-dashboard/committee-votes/committee-vote/committee-vote.component';
import { CommitteeApprovalsComponent } from '../committee-approval-dashboard/committee-approvals/committee-approvals.component';
import { MilestoneSectionsComponent } from '../committee-approval-dashboard/milestone-sections/milestone-sections.component';
import { MatTableModule } from '@angular/material/table';
import { TableComponent } from './table/table.component';
import { MatSortModule } from '@angular/material/sort';
import { TimelineComponent } from './timeline/timeline.component';
import { CommitteeApprovalsModule } from '../committee-approval-dashboard/committee-approvals/committee-approvals.module';
import { CommitteeConditionsModule } from '../committee-approval-dashboard/committee-conditions/committee-conditions.module';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { JumpToSectionComponent } from './jump-to-section/jump-to-section.component';
import { JumpToTopComponent } from './jump-to-top/jump-to-top.component';
import { BubbleLineComponent } from './timeline/bubble-line/bubble-line.component';
import { SubStatusesComponent } from './timeline/sub-statuses/sub-statuses.component';
import { SubStatusDateComponent } from './timeline/sub-status-date/sub-status-date.component';
import { SubStatusDatesTableComponent } from './timeline/sub-status-dates-table/sub-status-dates-table.component';
import { DateTargetIndicatorComponent } from './date-target-indicator/date-target-indicator.component';
import { SubStatusDatepickerComponent } from './timeline/sub-status-datepicker/sub-status-datepicker.component';
import { CreditOutletTableComponent } from './credit-outlet-table/credit-outlet-table.component';
import { DispositionSectionComponent } from './disposition-section/disposition-section.component';
import { DispositionFormComponent } from './disposition-section/disposition-form/disposition-form.component';
import { NullableBooleanComponent } from './nullable-boolean/nullable-boolean.component';
import { SimpleCheckboxComponent } from './simple-checkbox/simple-checkbox.component';
import { DispositionDateComponent } from './disposition-section/disposition-date/disposition-date.component';
import { DispositionDistributionComponent } from './disposition-section/disposition-distribution/disposition-distribution.component';
import { DispositionDistributionProceedComponent } from './disposition-section/disposition-distribution-proceed/disposition-distribution-proceed.component';
import { FreeformOrgSearchComponent } from './disposition-section/freeform-org-search/freeform-org-search.component';
import { RecipientDialogComponent } from './disposition-section/recipient-dialog/recipient-dialog.component';
import { DispositionsDetailsComponent } from './dispositions-details/dispositions-details.component';
import { ContactLinkComponent } from './contact-link/contact-link.component';
import { EmbeddedReportComponent } from './embedded-report/embedded-report.component';
import { CommitteeReportsComponent } from '../committee-approval-dashboard/committee-reports/committee-reports.component';
import { AddCompanyEventModalComponent } from './add-company-event-modal/add-company-event-modal.component';
import {MatRadioModule} from "@angular/material/radio";
import {
  CommitteeDealDatesComponent
} from "../committee-approval-dashboard/committee-deal-dates/committee-deal-dates.component";
import { SubStatusTimepickerComponent } from './timeline/sub-status-timepicker/sub-status-timepicker.component';

import { WarehouseLineComponent } from './timeline/warehouse-line/warehouse-line.component';

import { EmployeeSearchComponent } from './employee-search/employee-search.component';
import { AssignmentsModalComponent } from './assignments-modal/assignments-modal.component';
import { SimpleListModalComponent } from './simple-list-modal/simple-list-modal.component';
import { AnalystSearchComponent } from './analyst-search/analyst-search.component';
import { TypeaheadComponent } from './typeahead/typeahead.component';
import {CurrencyParserDirective} from "../directives/currency-parser.directive";
import { ContactsNavigationComponent } from './contacts-navigation/contacts-navigation.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";

import { AddressAutocompleteComponent } from "./address-autocomplete/address-autocomplete.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatCardModule,
    MatSelectModule,
    MatRadioModule,
    MatToolbarModule,
    MatSidenavModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatGridListModule,
    MatCheckboxModule,
    MatTooltipModule,
    FormsModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatStepperModule,
    CommitteeApprovalsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommitteeConditionsModule,
    AngularEditorModule,
    MatButtonToggleModule
  ],
  declarations: [
    TopBarTabsComponent,
    JupiterRedirectComponent,
    CalendarTooltipComponent,
    CommitteeApprovalDashboardComponent,
    DisclosuresEditorComponent,
    CommitteeDealInformationComponent,
    CommitteeLinksComponent,
    CommitteeVoteComponent,
    CommitteeVotesComponent,
    MilestoneSectionsComponent,
    TableComponent,
    TimelineComponent,
    ConfirmationModalComponent,
    JumpToSectionComponent,
    JumpToTopComponent,
    BubbleLineComponent,
    SubStatusesComponent,
    SubStatusDateComponent,
    SubStatusDatesTableComponent,
    DateTargetIndicatorComponent,
    SubStatusDatepickerComponent,
    CreditOutletTableComponent,
    DispositionSectionComponent,
    DispositionFormComponent,
    NullableBooleanComponent,
    SimpleCheckboxComponent,
    DispositionDateComponent,
    DispositionDistributionComponent,
    DispositionDistributionProceedComponent,
    FreeformOrgSearchComponent,
    RecipientDialogComponent,
    DispositionsDetailsComponent,
    ContactLinkComponent,
    EmbeddedReportComponent,
    CommitteeReportsComponent,
    AddCompanyEventModalComponent,
    CommitteeDealDatesComponent,
    SubStatusTimepickerComponent,
    WarehouseLineComponent,
    EmployeeSearchComponent,
    AssignmentsModalComponent,
    SimpleListModalComponent,
    AnalystSearchComponent,
    AddressAutocompleteComponent,
    ContactsNavigationComponent,
    TypeaheadComponent
  ],
  exports: [
    TopBarTabsComponent,
    JupiterRedirectComponent,
    CalendarTooltipComponent,
    CommitteeApprovalDashboardComponent,
    DisclosuresEditorComponent,
    CommitteeDealInformationComponent,
    CommitteeLinksComponent,
    CommitteeApprovalsComponent,
    MilestoneSectionsComponent,
    TableComponent,
    TimelineComponent,
    JumpToSectionComponent,
    JumpToTopComponent,
    CreditOutletTableComponent,
    DispositionSectionComponent,
    NullableBooleanComponent,
    DispositionsDetailsComponent,
    ContactLinkComponent,
    EmbeddedReportComponent,
    CommitteeReportsComponent,
    CommitteeDealDatesComponent,
    EmployeeSearchComponent,
    AnalystSearchComponent,
    AddressAutocompleteComponent,
    ContactsNavigationComponent,
    TypeaheadComponent
  ]
})
export class SharedModule {}
